import { useState, useEffect } from 'react';

export const useToast = (delay = 4000) => {
  const [toastMessage, setToastMessage] = useState(null);

  useEffect(() => {
    if (toastMessage) {
      const timer = setTimeout(() => setToastMessage(null), delay);
      return () => clearTimeout(timer);
    }
  }, [toastMessage, delay]);

  const showToast = message => {
    setToastMessage(message);
  };
  const closeToast = () => setToastMessage(null);

  return { toastMessage, showToast, closeToast };
};
